import { createComponent, createHook } from 'reakit-system';
import { useBox } from '../../Box/Box';
import { useField } from '../../Field/Field';
import type { StepperFieldHTMLProps, StepperFieldOptions } from '../types';

export const useStepperFieldWrapper = createHook<
  StepperFieldOptions,
  StepperFieldHTMLProps
>({
  name: 'StepperFieldWrapper',
  compose: [useBox, useField],
  useOptions(options) {
    return {
      ...options,
      bg: 'white',
      display: 'flex',
      flexWrap: 'wrap',
      borderRadius: 'stepperBorderRadius',
      padding: 'stepperFieldPadding',
      styles: {
        gap: 'sp-4',
        '> button, div.input_wrapper input': {
          flexGrow: 1,
          flexBasis: 'calc((12rem - 100%) * 999)',
        },
        ':hover': {
          backgroundColor: 'white !important',
        },
      },
    };
  },
});

export const StepperFieldWrapper = createComponent({
  as: 'div',
  useHook: useStepperFieldWrapper,
  memo: true,
});
